import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { IParentStyle } from "@dineout-payment-success-ui/interfaces/TableReservation";

export const ComponentWrapper = styled.div<{
    parentStyle?: IParentStyle;
}>(({ theme, parentStyle }) => ({
    background: parentStyle
        ? `linear-gradient(${parentStyle.angle}deg, ${parentStyle.gradientColor.join(", ")})`
        : theme.colors[theme.colorMode].positive_Sub,
    color: theme.colors[theme.colorMode].positive,
    padding: theme.spacing.small,
    borderRadius: theme.cornerRadius.medium,
    display: "flex",
    alignItems: "end",
    justifyContent: "space-between",
}));

export const TitleText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].positive,
    width: "90%",
}));
